/**
 * Copyright © Veeam Software Group GmbH.
 */

import { JobStateRepresentation } from '@veeam-vspc/models/web-controllers';

export type EJobStatuses = JobStateRepresentation;
export const EJobStatuses = JobStateRepresentation;
